import type {
  AggregateOffer,
  UnitPriceSpecification,
} from "apps/commerce/types.ts";

const bestInstallment = (
  acc: UnitPriceSpecification | null,
  curr: UnitPriceSpecification,
) => {
  if (curr.priceComponentType !== "https://schema.org/Installment") {
    return acc;
  }

  if (!acc) {
    return curr;
  }

  if (acc.price > curr.price) {
    return curr;
  }

  if (acc.price < curr.price) {
    return acc;
  }

  if (
    acc.billingDuration && curr.billingDuration &&
    acc.billingDuration < curr.billingDuration
  ) {
    return curr;
  }

  return acc;
};

const formatInstallments = (
  installment: UnitPriceSpecification,
  sellingPrice: number,
) => {
  const { billingDuration, billingIncrement, price } = installment;

  if (!billingDuration || !billingIncrement) return;

  const withTaxes = sellingPrice < price;

  return {
    count: billingDuration,
    value: billingIncrement,
    withTaxes,
  };
};

export const useOffer = (aggregateOffer?: AggregateOffer) => {
  const offer = aggregateOffer?.offers[0];
  const listPrice = offer?.priceSpecification.find((spec) =>
    spec.priceType === "https://schema.org/ListPrice"
  )?.price;
  const installment = offer?.priceSpecification.reduce(bestInstallment, null);
  const seller = offer?.seller;
  const price = offer?.price;
  const paymentMethods = offer?.priceSpecification;
  const availability = offer?.availability;
  const discount = listPrice && price && listPrice !== price
    ? Math.round((1 - (price / listPrice)) * 100)
    : 0;
  const currency = aggregateOffer?.priceCurrency;
  const inventoryLevel = offer?.inventoryLevel.value;

  return {
    price,
    listPrice,
    discount,
    availability,
    seller,
    paymentMethods,
    installment,
    currency,
    installments: installment && price
      ? formatInstallments(installment, price)
      : undefined,
    inventoryLevel,
  };
};
